import React, { useRef } from 'react';
import { PressureTracker } from '../../PressureTracker';
import { DataFeed } from '../../DataFeed';
import { WolframCA } from '../../WolframCA';
import { NewsBox } from '../../NewsBox';
import { Footer } from '../../Footer';
import * as S from './Terminal.style';
import { Acceleration } from '../../Charts/Acceleration/Acceleration.component';
import { useResizeObserver } from '../../../hooks/useResizeObserver';
import { MarketActivity } from '../../Charts/MarketActivity/MarketActivity.component';

const Terminal = () => {
  const marketActivityRef = useRef<HTMLDivElement>(null);
  const accelerationRef = useRef<HTMLDivElement>(null);
  const marketSize = useResizeObserver(marketActivityRef);
  const accelerationSize = useResizeObserver(accelerationRef);

  return (
    <>
      <S.TerminalShell>
        <S.TerminalGrid>
          <S.Panel $area="feed">
            <S.PanelHeader>
              <S.HeaderText>
                <S.PanelKicker>state model</S.PanelKicker>
                <S.PanelTitle>Bitcoin Microstructure State</S.PanelTitle>
              </S.HeaderText>
              <S.PanelMeta>live</S.PanelMeta>
            </S.PanelHeader>
            <S.PanelBody $flush>
              <DataFeed />
            </S.PanelBody>
          </S.Panel>

          <S.Panel $area="pressure">
            <S.PanelHeader>
              <S.HeaderText>
                <S.PanelKicker>pressure</S.PanelKicker>
                <S.PanelTitle>Orderflow Imbalance</S.PanelTitle>
              </S.HeaderText>
              <S.PanelMeta>ticks</S.PanelMeta>
            </S.PanelHeader>
            <S.PanelBody>
              <S.BodyFrame>
                <PressureTracker />
              </S.BodyFrame>
            </S.PanelBody>
          </S.Panel>

          <S.Panel $area="automata">
            <S.PanelHeader>
              <S.HeaderText>
                <S.PanelKicker>automata</S.PanelKicker>
                <S.PanelTitle>Markov State Transitions</S.PanelTitle>
              </S.HeaderText>
              <S.PanelMeta>byte state</S.PanelMeta>
            </S.PanelHeader>
            <S.PanelBody>
              <S.BodyFrame>
                <WolframCA />
              </S.BodyFrame>
            </S.PanelBody>
          </S.Panel>

          <S.Panel $area="activity">
            <S.PanelHeader>
              <S.HeaderText>
                <S.PanelKicker>Pattern Frequency (8-tick)</S.PanelKicker>
                <S.PanelTitle>Orderflow Sequence Distribution</S.PanelTitle>
              </S.HeaderText>
              <S.PanelMeta>treemap</S.PanelMeta>
            </S.PanelHeader>
            <S.PanelBody ref={marketActivityRef}>
              <S.BodyFrame>
                <MarketActivity size={marketSize} />
              </S.BodyFrame>
            </S.PanelBody>
          </S.Panel>

          <S.Panel $area="acceleration">
            <S.PanelHeader>
              <S.HeaderText>
                <S.PanelKicker>acceleration</S.PanelKicker>
                <S.PanelTitle>Acceleration–Speed Density</S.PanelTitle>
              </S.HeaderText>
              <S.PanelMeta>phase space</S.PanelMeta>
            </S.PanelHeader>
            <S.PanelBody ref={accelerationRef}>
              <S.BodyFrame>
                <Acceleration size={accelerationSize} />
              </S.BodyFrame>
            </S.PanelBody>
          </S.Panel>
        </S.TerminalGrid>
      </S.TerminalShell>
      <NewsBox />
      <Footer />
    </>
  );
};

export { Terminal };
